import PropTypes from 'prop-types';
import React from 'react';
import {
  Box,
  Slide,
  Stack,
  Button,
  TextField,
  Typography,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel
} from '@mui/material';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as myLayananService from '../../../services/mylayanan';
import * as spl from '../../../services/spl';
import * as tokenServices from '../../../services/token';
import RequestsSPLPServices from './RequestsSPLPServices';

RequestsSPLP.propTypes = {
  user: PropTypes.object.isRequired
};

export default function RequestsSPLP({ user }) {
  const [nama, setNama] = React.useState('');
  const navigate = useNavigate();
  const [splservice, setSPLService] = React.useState([]);
  const [choose, setChoose] = React.useState({});
  const [tipeAplikasi, setTipeAplikasi] = React.useState('web');
  const [token, setToken] = React.useState('');

  const theme = useTheme();

  const createPermohonan = async () => {
    if (!user?.attributes?.id_instansi) return toast.error('ID Instansi tidak ditemukan');
    if (!user?.attributes?.id) return toast.error('ID User tidak ditemukan');
    if (!nama) return toast.error('Nama aplikasi harus diisi');

    try {
      const body = {
        data: {
          type: 'splp',
          id: '1',
          attributes: {
            id_kategori_layanan: 'splp',
            id_instansi: user?.attributes?.id_instansi,
            requestor: user?.attributes?.id,
            status: 'draft',
            id_jenis_permohonan: 'splp'
          },
          meta: {
            splp: {
              name: nama,
              choose,
              tipe_aplikasi: tipeAplikasi
            }
          }
        }
      };

      const result = await myLayananService.addLayanan(body);

      if (result) {
        try {
          if (token) {
            const tokenBody = {
              id: token,
              used_by: user?.attributes?.id
            };
            const tokenResult = await tokenServices.updateToken(tokenBody);

            if (tokenResult) {
              toast.success('Draft Permohonan berhasil dibuat');
              navigate(
                `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
                {
                  replace: true
                }
              );
            }
          } else {
            toast.success('Draft Permohonan berhasil dibuat');
            navigate(
              `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
              {
                replace: true
              }
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Get Paket
  const getSPLService = async () => {
    try {
      const result = await spl.getSPLServices();
      setSPLService(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getSPLService();
  }, []);

  const chooseService = async (item) => {
    if (!_.isEmpty(item)) {
      setChoose({ value: item.name, id: item.id, meta: item.tags });
      console.log('data', choose);
    } else {
      setChoose({});
    }
  };

  return (
    <>
      <Slide direction="left" in="true" mountOnEnter unmountOnExit>
        <Box sx={{ flexDirection: 'column' }}>
          <Stack
            spacing={3}
            direction="column"
            divider={<Divider orientation="horizontal" flexItem />}
          >
            <Box>
              <Typography variant="body2">
                Pilih kategori layanan sesuai dengan yang anda butuhkan.
              </Typography>
            </Box>
            <Box>
              <FormControl>
                <FormLabel id="aplikasi-label">Jenis Aplikasi</FormLabel>
                <RadioGroup
                  aria-labelledby="aplikasi-aria-label"
                  defaultValue={tipeAplikasi}
                  name="aplikasi-group"
                  onChange={(e) => setTipeAplikasi(e.target.value)}
                >
                  <FormControlLabel value="web" control={<Radio />} label="Web" />
                  <FormControlLabel value="mobile" control={<Radio />} label="Mobile" />
                </RadioGroup>
              </FormControl>
            </Box>
            <Stack direction="column" spacing={1}>
              <Stack spacing={2} direction="row" alignItems="center">
                <Box sx={{ flex: 4 }}>
                  <TextField
                    type="text"
                    value={nama}
                    onChange={(e) => setNama(e.target.value)}
                    size="medium"
                    label="Masukkan nama aplikasi"
                    fullWidth
                  />
                </Box>
              </Stack>
              <Box>
                <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                  Isikan nama aplikasi yang akan menggunakan layanan
                </Typography>
              </Box>
            </Stack>
            <Box>
              <RequestsSPLPServices user={user} item={splservice} handleClick={chooseService} />
              <Divider />
              <Stack direction="column" spacing={1} mt={2}>
                <Stack direction="column" spacing={2}>
                  <Box>
                    <Typography variant="h5">Preview permohonan</Typography>
                    <Typography variant="body2">Nama Aplikasi : {nama}</Typography>
                    <Typography variant="body2">
                      Jenis Aplikasi :{' '}
                      {tipeAplikasi === 'web'
                        ? 'Aplikasi berbasis web'
                        : 'Aplikasi berbasis mobile'}
                    </Typography>
                    <Typography variant="body2">Pilihan Service : {choose?.value}</Typography>
                  </Box>
                  <Box>
                    <Button
                      onClick={() => createPermohonan()}
                      disabled={_.isEmpty(choose) && _.isEmpty(nama)}
                      variant="contained"
                    >
                      BUAT PERMOHONAN
                    </Button>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Slide>
    </>
  );
}
